import React from 'react';
import styled from 'styled-components';
import CardButton from './CardButton';
import { MobileWidth } from '../sharedData/Constants';

const Card = (props) => {
    return (
        <StyledCard>
            <Icon src={props.data.icon} alt={props.data.title} />
          <Title>
            {props.data.title}
          </Title>
          <Subtitle>
            {props.data.subtitle}
          </Subtitle>
          <Text>
          <div dangerouslySetInnerHTML={{ __html: props.data.text }} />
          </Text>
          <CardButton link={props.data.link} title={props.data.buttonTitle}/>
        </StyledCard>
    );
}

const Icon = styled.img`
  width: 124px;
  height: 124px;
  position: absolute;
  top: -68px;
  left: calc(50% - 62px);
  @media screen and (max-width: ${MobileWidth}){
    width: 67px;
    height: 67px;
    top: unset;
    bottom: -20px;
    left: 240px;
  }
`;

const Title = styled.div`
  font-family: Work Sans;
  font-weight: 700;
  font-size: 36px;
  color: #ffffff;
  margin-top: 40px;
  @media screen and (max-width: ${MobileWidth}){
    font-size: 24px;
    margin-top: 10px;
  }
`;

const Subtitle = styled.div`
  font-family: Work Sans;
  font-weight: 400;
  font-size: 27px;
  color: #ffffff;
  @media screen and (max-width: ${MobileWidth}){
    font-size: 15px;
  }
`;

const Text = styled.div`
  font-family: Work Sans;
  font-size: 20px;
  color: #ffffff;
  width: 570px;
  font-weight: 200;
  margin-top: 20px;
  text-align: center;
  line-height: 23px;
  span{
    font-weight: bold;
  }
  @media screen and (max-width: ${MobileWidth}){
    font-size: 12px;
    width: 296px;
    margin-top: 10px;
    text-align: start;
    line-height: 18px;
  }
`;

const StyledCard = styled.div`
  width: 730px;
  background: linear-gradient(0deg, #14BBBC -36%, rgba(0, 0, 0, 0) 28%);
  height: 390px;
  position: relative;
  margin-bottom: 101px;
  border: 2px solid #E4E4E4;
  background-repeat: no-repeat;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${MobileWidth}){
    width: 337px;
    height: 250px;
    padding-left: 25px;
    align-items: baseline;
    margin-bottom: 25px;
  }
  @media screen and (max-width: 349px){
    width: 315px;
    padding-left: 10px;
  }
`;

export default Card;